class LabelForContentType {

    constructor(){
        return contentType => {
                let label = "Unknown (" + contentType + ")";
                switch(contentType) {
                case "image/jpg":
                case "image/jpeg":
                    label = "Image (JPEG)";
                    break;
                case "image/png":
                    label = "Image (PNG)";
                    break;
                case "image/gif":
                    label = "Image (GIF)";
                    break;
                case "video/mp4":
                    label = "Video (MP4)";
                    break;
                case "video/mov":
                case "video/quicktime":
                    label = "Video (MOV)";
                    break;
                case "text/plain":
                    label = "Text (TXT)";
                    break;
                case "text/html":
                    label = "HTML";
                    break;
                case "text/csv":
                    label = "Text (CSV)";
                    break;
                case "application/x-shockwave-flash":
                    label = "Flash";
                    break;
                case "x-reflow/rss-feed":
                    label = "RSS Feed";
                    break;
                case "x-reflow/adunit":
                    label = "Ad Unit";
                    break;
                case "x-reflow/campaign; publish":
                    label = "Publish";
                    break;
                case "x-reflow/campaign":
                    label = "Campaign";
                    break;
                case "x-reflow/trackset":
                    label = "Client Tracking";
                    break;
                case "x-reflow/user":
                    label = "User";
                    break;
                case "x-reflow/group":
                    label = "Group";
                    break;
                case "x-reflow/product-feed":
                    label = "Product Feed";
                    break;
                }
                return label;
        };
    }

}

angular.module('cpm')
.filter('labelForContentType', [ () => {
    'use strict';
    return new LabelForContentType();
}]);

